var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.5 50",
    style: {
      enableBackground: "new 0 0 217.5 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4D4D4D;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:url(#SVGID_14_);}\n\t.st15{fill:url(#SVGID_15_);}\n\t.st16{fill:url(#SVGID_16_);}\n\t.st17{fill:url(#SVGID_17_);}\n\t.st18{fill:url(#SVGID_18_);}\n\t.st19{fill:url(#SVGID_19_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,11.1h2.8v10.4l11.1-10.4h3.7L66.8,23.6l14.4,15.3h-3.7L65.4,26v13h-2.8V11.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,18.4v20.6h-2.6v-3.5c-1.1,1.3-2.4,2.4-3.7,3c-1.4,0.7-2.9,1-4.5,1c-2.9,0-5.4-1.1-7.5-3.2 c-2.1-2.1-3.1-4.7-3.1-7.7c0-3,1-5.5,3.1-7.6c2.1-2.1,4.6-3.2,7.5-3.2c1.7,0,3.2,0.4,4.6,1.1c1.4,0.7,2.6,1.8,3.6,3.2v-3.8H105.5 z M94.9,20.4c-1.5,0-2.8,0.4-4.1,1.1c-1.2,0.7-2.2,1.7-3,3.1c-0.7,1.3-1.1,2.7-1.1,4.2c0,1.4,0.4,2.8,1.1,4.2 c0.7,1.3,1.7,2.4,3,3.1c1.3,0.7,2.6,1.1,4,1.1c1.4,0,2.8-0.4,4.1-1.1c1.3-0.7,2.3-1.7,3-3c0.7-1.2,1-2.6,1-4.2 c0-2.4-0.8-4.4-2.4-6C99.1,21.2,97.2,20.4,94.9,20.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.4,18.4h2.6v3.6c0.9-1.3,1.9-2.3,2.8-2.9c1.3-0.8,2.7-1.2,4.2-1.2c1,0,1.9,0.2,2.8,0.6 c0.9,0.4,1.6,0.9,2.2,1.6c0.6,0.6,1.1,1.6,1.5,2.8c0.9-1.6,2-2.8,3.3-3.7c1.3-0.8,2.7-1.3,4.3-1.3c1.4,0,2.7,0.4,3.8,1.1 c1.1,0.7,1.9,1.7,2.4,3c0.5,1.3,0.8,3.2,0.8,5.8v11.2h-2.7V27.7c0-2.2-0.2-3.7-0.5-4.5c-0.3-0.8-0.9-1.5-1.6-2 c-0.8-0.5-1.7-0.8-2.7-0.8c-1.3,0-2.5,0.4-3.5,1.1s-1.8,1.8-2.3,3s-0.7,3.4-0.7,6.3v8.1h-2.6V28.4c0-2.5-0.2-4.2-0.5-5.1 c-0.3-0.9-0.8-1.6-1.6-2.1c-0.8-0.5-1.7-0.8-2.7-0.8c-1.2,0-2.4,0.4-3.4,1.1c-1.1,0.7-1.9,1.7-2.4,3c-0.5,1.2-0.8,3.2-0.8,5.7 v8.7h-2.6V18.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165,32.1l2.2,1.2c-0.7,1.4-1.6,2.6-2.5,3.5c-1,0.9-2,1.6-3.2,2c-1.2,0.5-2.6,0.7-4.1,0.7 c-3.4,0-6-1.1-7.9-3.3c-1.9-2.2-2.8-4.7-2.8-7.5c0-2.6,0.8-4.9,2.4-7c2-2.6,4.7-3.9,8.2-3.9c3.5,0,6.3,1.3,8.4,4 c1.5,1.9,2.2,4.2,2.3,7h-18.5c0,2.4,0.8,4.3,2.3,5.9c1.5,1.5,3.3,2.3,5.5,2.3c1,0,2.1-0.2,3.1-0.5c1-0.4,1.8-0.8,2.5-1.5 C163.5,34.4,164.2,33.5,165,32.1z M165,26.6c-0.4-1.4-0.9-2.5-1.5-3.4c-0.7-0.8-1.6-1.5-2.7-2c-1.1-0.5-2.3-0.8-3.5-0.8 c-2,0-3.8,0.6-5.2,1.9c-1.1,0.9-1.9,2.4-2.4,4.3H165z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.9,18.4h2.7v3c0.8-1.2,1.7-2.1,2.6-2.7c0.9-0.6,1.8-0.9,2.8-0.9c0.7,0,1.5,0.2,2.3,0.7l-1.4,2.2 c-0.6-0.2-1-0.4-1.4-0.4c-0.9,0-1.7,0.4-2.6,1.1c-0.8,0.7-1.4,1.8-1.9,3.4c-0.3,1.2-0.5,3.5-0.5,7.1v7h-2.7V18.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.3718,
    y1: 18.9699,
    x2: 202.8254,
    y2: 38.4235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#006EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    style: {
      stopColor: "#00A481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C05B"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.3,11.1l13,27.8h-3l-4.4-9.2h-12l-4.3,9.2h-3.1l13.1-27.8H196.3z M196,17l-4.8,10.1h9.5L196,17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.9632,
    y1: 6.3785,
    x2: 215.4168,
    y2: 25.8321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#006EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    style: {
      stopColor: "#00A481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C05B"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.2,11.1h2.8v27.8h-2.8V11.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.7877,
    y1: 18.3185,
    x2: 97.7994,
    y2: 39.0058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#006EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7468,
    style: {
      stopColor: "#00A481"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C05B"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.9,22.4c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5c3.6,0,6.5-2.9,6.5-6.5 C101.4,25.3,98.5,22.4,94.9,22.4z M99.9,28.9c0,2.8-2.2,5-5,5c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3 c1.6,0,3-1.3,3-3c0-0.6,0.4-1,1-1C99.4,27.9,99.9,28.4,99.9,28.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9519,
    y1: -6.2545,
    x2: 14.3315,
    y2: 31.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.2,30.6c1.1-0.1,1.9-0.4,2.6-1c0.9-0.8,1.8-1,2.7-0.1c0.9,0.9,0.8,1.8,0,2.8c-1.4,1.8-1.4,3.3,0,5.1 c0.8,1,0.9,1.9,0,2.8c-0.7,0.7-1.6,0.7-2.5,0.1c-0.9-0.7-0.9-1.8,0-2.9c1-1.3,1.2-2.7,0.5-4.2c-0.7-1.4-1.8-2-3.4-2 c-1.4,0-2.5,0.7-3.1,1.9c-0.7,1.2-0.6,2.5,0.2,3.7c0.3,0.4,0.6,0.7,0.8,1.2c0.4,0.9,0.2,1.7-0.6,2.3c-0.8,0.6-1.6,0.6-2.4-0.1 c-0.7-0.6-0.9-1.5-0.4-2.3c0.3-0.6,0.9-1.1,1.1-1.8c0.5-1.6,0.1-3.1-1.2-4.1c-1.3-1-2.9-1.1-4.3-0.2c-0.3,0.2-0.5,0.4-0.8,0.6 C3.7,33,2.7,32.9,2,32.1c-0.7-0.8-0.7-1.7,0-2.5c0.7-0.8,1.6-0.9,2.6-0.2c0.2,0.2,0.4,0.4,0.7,0.5c1.6,1.1,3.4,0.9,4.7-0.4 c1.3-1.3,1.4-3.2,0.4-4.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.7-0.9-0.9-1.8,0-2.7c0.8-0.8,1.8-0.8,2.6,0c0.9,0.8,0.8,1.8,0.1,2.7 c-1.1,1.3-1.3,2.7-0.7,4.3C12.7,30,13.9,30.4,15.2,30.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.0351,
    y1: 1.8438,
    x2: 23.4146,
    y2: 39.5532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.5,19c0-1-0.3-1.8-1-2.5c-0.8-0.9-0.9-1.9,0-2.8c0.7-0.7,1.7-0.8,2.5,0c0.9,0.9,0.9,1.8,0,2.8 c-1.1,1.2-1.3,2.7-0.6,4.1c0.6,1.3,1.8,2,3.2,2c1.5,0,2.6-0.6,3.2-2c0.6-1.3,0.5-2.5-0.2-3.7c-0.2-0.2-0.4-0.4-0.5-0.7 c-0.6-0.9-0.6-1.8,0.2-2.6c0.7-0.7,1.6-0.7,2.4-0.1c0.9,0.7,1,1.6,0.4,2.6c-0.1,0.1-0.2,0.2-0.3,0.3c-1.3,1.7-1.3,3.3,0,5 c0.8,1,0.8,1.8,0,2.8c-1.4,1.8-1.4,3.2,0,5.1c0.7,0.9,0.9,1.8,0,2.7c-0.8,0.7-1.7,0.8-2.5,0.1c-1-0.9-0.9-1.8-0.1-2.8 c1.3-1.8,1.3-3.8-0.1-5.2c-1.3-1.3-3.3-1.3-4.9,0c-1,0.8-1.9,0.8-2.9,0c-1.9-1.4-3.2-1.4-5.2,0.1c-1,0.7-1.9,0.7-2.7-0.2 c-0.7-0.8-0.7-1.7,0-2.5c0.8-0.9,1.8-0.8,2.7-0.1c1.9,1.4,3.7,1.4,5.2,0C34.2,20.9,34.5,20,34.5,19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.9388,
    y1: -1.8084,
    x2: 19.3183,
    y2: 35.9011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26.9,26.6c1,0,1.9-0.4,2.6-1c0.9-0.8,1.8-0.7,2.7,0c1.9,1.5,3.2,1.5,5.2,0c1.1-0.8,2.2-0.7,2.9,0.2 c0.6,0.9,0.4,2-0.5,2.6c-0.8,0.5-1.5,0.4-2.3-0.1c-2.3-1.6-3.2-1.6-5.4,0c-1,0.7-1.8,0.7-2.7-0.1c-1.7-1.4-3.7-1.4-5.1,0.1 c-1.3,1.4-1.4,3.5-0.1,4.9c1.4,1.6,3.4,1.7,5.3,0.3c1.3-1,2.9-0.7,3.2,0.7c0.2,0.8,0,1.5-0.7,2c-0.7,0.5-1.5,0.5-2.1,0 c-1.9-1.6-3.7-1.7-5.7-0.1c-0.7,0.6-1.6,0.6-2.4-0.1c-0.8-0.7-0.9-1.7-0.3-2.5c1.6-1.9,1.6-3.7,0-5.7c-0.7-0.9-0.5-1.8,0.2-2.6 c1.3-1.7,1.4-3.3,0.1-5c-0.8-1-1.1-2,0-2.9c0.8-0.7,1.7-0.7,2.5,0c0.9,0.8,0.9,1.7,0,2.9c-1,1.3-1.2,2.7-0.5,4.2 C24.4,25.9,25.4,26.6,26.9,26.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.0935,
    y1: -11.4777,
    x2: 8.473,
    y2: 26.2317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.6,19.3c-1.5,0-2.7,0.6-3.4,1.9c-0.7,1.3-0.6,2.6,0.2,3.8c0.2,0.2,0.4,0.4,0.5,0.7 c0.7,0.9,0.7,1.8-0.2,2.6C8,28.9,7.1,29,6.3,28.3c-0.9-0.8-0.9-1.7-0.2-2.7c1.5-2.1,1.5-3.2,0.1-5.3c-0.6-0.9-0.8-1.8,0-2.6 c0.8-0.9,1.8-0.8,2.7-0.1c1.9,1.4,3.2,1.4,5.2,0c0.9-0.7,1.8-0.8,2.6,0c0.9,0.8,0.8,1.8,0.1,2.7c-1.5,2.1-1.5,3.2,0.1,5.3 c0.7,1,0.7,1.9-0.2,2.7c-0.8,0.7-1.7,0.7-2.5,0c-0.9-0.8-0.9-1.8-0.1-2.7c1.1-1.3,1.4-2.7,0.7-4.3C14.1,20,12.9,19.3,11.6,19.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1769,
    y1: -3.3792,
    x2: 17.5564,
    y2: 34.3302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M30.9,21c-0.8-0.1-1.3-0.4-1.7-1.1c-0.4-0.7-0.2-1.4,0.2-2c1.6-2.5,1.7-3.2,0-5.5c-0.6-0.8-0.7-1.7,0.1-2.5 c0.8-0.8,1.7-0.8,2.6-0.2c2.3,1.6,3,1.6,5.4,0c0.9-0.6,1.7-0.6,2.5,0.1c0.8,0.7,0.7,1.6,0.2,2.5c-1.6,2.4-1.6,3.1,0,5.5 c0.6,0.9,0.6,1.7-0.2,2.5c-0.8,0.7-1.7,0.7-2.5,0.1c-0.9-0.7-1-1.7-0.3-2.6c0.8-1,1.4-2,1.2-3.3c-0.2-1.6-1.3-2.7-2.9-3 c-1.5-0.3-2.6,0.2-3.6,1.3c-0.9,1.2-1,2.9-0.3,4.2c0.2,0.4,0.5,0.7,0.8,1c0.4,0.7,0.4,1.3,0,2C32.1,20.7,31.5,20.9,30.9,21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.7489,
    y1: -10.8933,
    x2: 9.1285,
    y2: 26.8161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23.3,7.6c-1.2,0-2,0.3-2.7,1c-0.9,0.8-1.9,0.9-2.8,0c-0.7-0.8-0.7-1.6,0-2.5c0.8-0.9,1.7-0.9,2.9,0 c1.7,1.2,3.2,1.3,4.8,0c1-0.8,1.9-1,2.8-0.1c0.9,0.9,0.7,1.8-0.1,2.8c-1.4,1.7-1.3,3.1,0.1,5.1c0.8,1.1,0.6,2.2-0.4,2.9 c-0.9,0.6-2.1,0.3-2.6-0.6c-0.5-0.9-0.2-1.7,0.4-2.5c1.7-2.2,0.8-5.1-1.8-5.9C23.7,7.6,23.4,7.6,23.3,7.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.6141,
    y1: 5.9262,
    x2: 27.9936,
    y2: 43.6356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M46.3,17.1c1.6,0,2.7,1.6,1.8,2.8c-1.6,2.1-1.8,4,0,6c0.7,0.8,0.4,1.7-0.4,2.4c-0.8,0.7-1.7,0.6-2.5-0.1 c-0.7-0.7-1-1.6-0.3-2.4c1.7-1.9,1.7-3.8,0-5.8c-0.5-0.6-0.6-1.3-0.2-2C45.1,17.4,45.7,17.1,46.3,17.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.8121,
    y1: 1.6449,
    x2: 23.1916,
    y2: 39.3544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M30.9,31.1c-1,0-1.9,0.3-2.6,1c-0.9,0.8-1.9,0.9-2.8,0c-0.7-0.8-0.7-1.7-0.1-2.5c0.7-0.9,1.7-0.9,2.8-0.1 c1.9,1.4,3.3,1.5,5.2,0c1-0.7,1.9-0.9,2.8,0.1c0.7,0.8,0.7,1.7-0.1,2.5c-0.9,0.9-1.9,0.9-2.8,0C32.6,31.5,31.8,31.1,30.9,31.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.4995,
    y1: -9.3325,
    x2: 10.8791,
    y2: 28.3769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M17.4,22.9c0-0.5,0.2-0.9,0.5-1.3c1.5-2.1,1.5-3.2,0-5.3c-0.6-0.8-0.7-1.6-0.2-2.4c0.5-0.7,1.2-1,2-0.8 c1.3,0.3,1.8,1.8,1,3c-1.7,2.6-1.7,3.1,0,5.6c0.5,0.8,0.5,1.5,0,2.3c-0.5,0.7-1.2,0.9-2,0.7C17.9,24.5,17.4,23.8,17.4,22.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.1435,
    y1: -2.5174,
    x2: 18.5231,
    y2: 35.192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M17.2,42.7c0,0.8-0.4,1.4-1.2,1.8c-0.8,0.3-1.5,0.1-2.1-0.6c-0.6-0.6-0.7-1.4-0.2-2.1 c0.1-0.2,0.4-0.4,0.5-0.7c1.2-1.6,1.1-3.2-0.2-5c-0.7-0.9-0.9-1.8,0-2.7c0.8-0.8,1.7-0.8,2.6,0c0.9,0.8,0.8,1.7,0.1,2.7 c-1.5,2.1-1.5,3.2,0,5.3C17.1,41.9,17.2,42.3,17.2,42.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.2274,
    y1: -16.7077,
    x2: 2.6069,
    y2: 21.0017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M13.2,7.2c0,0.5-0.2,0.9-0.5,1.3c-1.5,2.1-1.5,3.1,0,5.3c0.8,1.1,0.6,2.3-0.4,2.9c-1,0.6-2.1,0.2-2.7-0.8 c-0.4-0.7-0.2-1.4,0.3-2c1.6-2.2,1.5-3.2,0-5.4C9.4,7.7,9.2,7,9.8,6.2c0.5-0.7,1.2-1.1,2.1-0.7C12.7,5.8,13.1,6.4,13.2,7.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.7133,
    y1: -17.166,
    x2: 2.0928,
    y2: 20.5434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3.4,13.2c0.8,0,1.3,0.4,1.7,1c0.4,0.6,0.4,1.3-0.1,1.9c-1.7,1.9-1.7,3.8,0,5.8c0.7,0.8,0.5,1.7-0.3,2.4 C3.9,25,3.1,25,2.3,24.4c-0.9-0.7-1-1.7-0.3-2.5c1.6-1.9,1.6-3.8,0-5.7c-0.5-0.6-0.5-1.3-0.1-2C2.2,13.5,2.8,13.3,3.4,13.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.5646,
    y1: -12.8408,
    x2: 6.9441,
    y2: 24.8687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M24.9,11.1c-0.1,0.8-0.4,1.4-1,1.7c-0.6,0.3-1.4,0.4-1.9-0.1c-1.9-1.7-3.8-1.6-5.8,0 c-0.8,0.7-1.7,0.4-2.4-0.4c-0.6-0.7-0.7-1.6,0-2.3c0.7-0.8,1.6-1.1,2.4-0.4c2,1.7,3.9,1.7,5.9,0c0.5-0.5,1.3-0.4,1.9-0.1 C24.6,9.9,24.9,10.5,24.9,11.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.3363,
    y1: -6.8033,
    x2: 13.7159,
    y2: 30.9061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M34.7,9.2c-1-0.1-1.7-0.7-1.8-1.8c-0.1-1,0.8-2,1.8-2c1,0,2,0.9,2,1.9C36.7,8.3,35.8,9.2,34.7,9.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.0778,
    y1: -18.6242,
    x2: 0.4573,
    y2: 19.0853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M9.4,11.2c0,1.1-0.8,1.9-1.9,1.9c-1.1,0-1.8-0.7-1.9-1.8c-0.1-1.1,0.8-1.9,1.8-2C8.5,9.3,9.4,10.1,9.4,11.2z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.7662,
    y1: -8.2032,
    x2: 12.1458,
    y2: 29.5063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0059E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    style: {
      stopColor: "#006ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#00A482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C15B"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M7.4,32.9c1,0,2,0.9,1.9,1.9c-0.1,1.1-0.7,1.8-1.8,1.8c-1.1,0.1-2-0.8-2-1.8C5.5,33.9,6.4,32.9,7.4,32.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.80692415f5af03bf7d6cc02edcbfe709.svg";
export { ForwardRef as ReactComponent };